import React, {useEffect, useState} from "react";
import withHeader from "../../../hocs/withHeader";
import withFooter from "../../../hocs/withFooter";
import TemplatesMenu from "./templates_table/TemplatesMenu";
import TemplatesList from "./templates_table/TemplatesList";
import TemplatesSearch from "./templates_table/TemplatesSearch";
import SurveysService from "../../../../services/SurveysService";
import {connect} from "react-redux";
import {Route, Switch, useLocation} from "react-router-dom";
import TemplatePreview from "./templates_preview/TemplatePreview";

function SurveyTemplatesPage(props) {
    var {match} = props;
    const isMobile = window.innerWidth < 756;
    const location = useLocation();

    const [menuTemplates, setMenuTemplates] = useState([]);
    const [searchTemplates, setSearchTemplates] = useState([]);
    const [isInSearch, setIsInSearch] = useState(false);
    const [selectedTemplateId, setSelectedTemplateId] = useState(undefined);
    const [isTemplateGettingCloned, setIsTemplateGettingCloned] = useState(false);

    useEffect(() => {
        fetchAllTemplatesList();
    }, []);

    useEffect(() => {
            !isMobile && setSelectedTemplateId(location.state && location.state.questId);
    }, [location.pathname]);

    const fetchAllTemplatesList = () => {
        SurveysService.getTemplates('', (res) => {
            const allTemplates = sortTemplatesByCategory(res.data);
            setMenuTemplates(allTemplates);
        });
    };

    const fetchSearchTemplatesList = (search = '') => {
        SurveysService.getTemplates(search, (res) => {
            const templates = sortTemplatesByCategory(res.data);
            setSearchTemplates(templates);
        });
    };

    const sortTemplatesByCategory = (templates) =>
        templates.sort((t1, t2) => t1.category.categoryOrder - t2.category.categoryOrder);

    const useTemplate = (templateId) => {
        if (props.isUserLoggedIn) {
            setIsTemplateGettingCloned(true);
            SurveysService.cloneSurvey(templateId,
                (succ) => {
                    setIsTemplateGettingCloned(false);
                    const newQuestId = succ.data;
                    props.history.push('/survey/builder/' + newQuestId);
                },
                (error) => {
                    setIsTemplateGettingCloned(false);
                }
            );
        } else {
            props.history.push('/login');
        }
    };

    const startFromScratch = () => {
        if (props.isUserLoggedIn) {
            props.history.push('/survey/builder/', {surveyName: "Untitled Survey"});
        }
        else {
            props.history.push('/login/');
        }
    }

    return (
        <section className={"template_builder " + (match.isExact ? "template--menuActive" : "template--questionsActive")}>
            <div className="template_builder__title">
                <h1>Survey Templates</h1>
                {isMobile && <TemplatesSearch
                    fetchSearchTemplatesList={fetchSearchTemplatesList}
                    setSearchTemplates={setSearchTemplates}
                    isInSearch={isInSearch}
                    setIsInSearch={setIsInSearch} />}
            </div>
            <div className="template">
                <TemplatesMenu
                    searchTemplates={searchTemplates}
                    setSearchTemplates={setSearchTemplates}
                    isInSearch={isInSearch}
                    setIsInSearch={setIsInSearch}
                    allTemplates={menuTemplates}
                    fetchSearchTemplatesList={fetchSearchTemplatesList}
                    selectedTemplateId={selectedTemplateId}
                    isMobile={isMobile}/>
                <Switch>
                    { !isMobile && <Route exact path={`${match.path}/`} render={(parentProps) => (<TemplatesList {...parentProps} isInSearch={isInSearch} templates={searchTemplates} allTemplates={menuTemplates}/>)}/> }
                    <Route exact path={`${match.path}/:surveyId`} render={(parentProps) => (<TemplatePreview isUserLoggedIn={props.isUserLoggedIn} {...parentProps} useTemplate={useTemplate} startFromScratch={startFromScratch} isTemplateGettingCloned={isTemplateGettingCloned}/>)}/>
                </Switch>
            </div>

        </section>
    );
}

const mapStateToProps = (state) => {
    return {
        isUserLoggedIn: state.user.loggedIn
    };
};

export default connect(mapStateToProps)(withHeader(withFooter(SurveyTemplatesPage)));